import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface ValeTransporteDisplayData {
  // IDA
  ida_integracao_onibus_metro?: boolean;
  ida_integracao_onibus_metro_valor?: number;
  ida_integracao_onibus_trem?: boolean;
  ida_integracao_onibus_trem_valor?: number;
  ida_onibus_municipal?: boolean;
  ida_onibus_municipal_valor?: number;
  ida_onibus_intermunicipal?: boolean;
  ida_onibus_intermunicipal_valor?: number;
  ida_metro_trem?: boolean;
  ida_metro_trem_valor?: number;
  ida_outros?: boolean;
  ida_outros_descricao?: string;
  ida_outros_valor?: number;
  
  // VOLTA
  volta_integracao_onibus_metro?: boolean;
  volta_integracao_onibus_metro_valor?: number;
  volta_integracao_onibus_trem?: boolean;
  volta_integracao_onibus_trem_valor?: number;
  volta_onibus_municipal?: boolean;
  volta_onibus_municipal_valor?: number;
  volta_onibus_intermunicipal?: boolean;
  volta_onibus_intermunicipal_valor?: number;
  volta_metro_trem?: boolean;
  volta_metro_trem_valor?: number;
  volta_outros?: boolean;
  volta_outros_descricao?: string;
  volta_outros_valor?: number;
  
  // Tipo de cartão
  tipo_cartao?: string;
  tipo_cartao_outros?: string;
  
  total_diario?: number;
}

interface ValeTransporteDisplayProps {
  data: ValeTransporteDisplayData | null;
  transporteConfirmado: boolean;
  onConfirmChange: (confirmed: boolean) => void;
}

export default function ValeTransporteDisplay({ 
  data, 
  transporteConfirmado, 
  onConfirmChange 
}: ValeTransporteDisplayProps) {
  if (!data) {
    return (
      <div className="text-center text-muted-foreground py-8">
        Nenhuma informação de vale transporte disponível.
      </div>
    );
  }

  const TransportItem = ({ label, valor }: { label: string; valor: number }) => (
    <div className="flex justify-between py-2 border-b">
      <span>{label}</span>
      <span className="font-medium">R$ {valor.toFixed(2)}</span>
    </div>
  );

  const getTipoCartaoLabel = () => {
    if (!data.tipo_cartao) return 'Não informado';
    
    switch (data.tipo_cartao) {
      case 'bilhete_unico': return 'Bilhete Único';
      case 'cartao_bom': return 'Cartão Top';
      case 'cartao_dia_facil': return 'Saldo Livre';
      case 'outros': return data.tipo_cartao_outros || 'Outros';
      default: return data.tipo_cartao;
    }
  };

  return (
    <div className="space-y-6">
      {/* Meios de Transporte - IDA */}
      <Card>
        <CardHeader>
          <CardTitle>Meios de Transporte — IDA</CardTitle>
        </CardHeader>
        <CardContent>
          {data.ida_integracao_onibus_metro && (
            <TransportItem 
              label="Integração Ônibus/Metrô" 
              valor={data.ida_integracao_onibus_metro_valor || 0} 
            />
          )}
          {data.ida_integracao_onibus_trem && (
            <TransportItem 
              label="Integração Ônibus/Trem" 
              valor={data.ida_integracao_onibus_trem_valor || 0} 
            />
          )}
          {data.ida_onibus_municipal && (
            <TransportItem 
              label="Ônibus Municipal" 
              valor={data.ida_onibus_municipal_valor || 0} 
            />
          )}
          {data.ida_onibus_intermunicipal && (
            <TransportItem 
              label="Ônibus Intermunicipal" 
              valor={data.ida_onibus_intermunicipal_valor || 0} 
            />
          )}
          {data.ida_metro_trem && (
            <TransportItem 
              label="Metrô ou Trem" 
              valor={data.ida_metro_trem_valor || 0} 
            />
          )}
          {data.ida_outros && (
            <TransportItem 
              label={`Outros${data.ida_outros_descricao ? ` (${data.ida_outros_descricao})` : ''}`} 
              valor={data.ida_outros_valor || 0} 
            />
          )}
          {!data.ida_integracao_onibus_metro && !data.ida_integracao_onibus_trem && 
           !data.ida_onibus_municipal && !data.ida_onibus_intermunicipal && 
           !data.ida_metro_trem && !data.ida_outros && (
            <p className="text-muted-foreground text-sm">Nenhum meio de transporte selecionado</p>
          )}
        </CardContent>
      </Card>

      {/* Meios de Transporte - VOLTA */}
      <Card>
        <CardHeader>
          <CardTitle>Meios de Transporte — VOLTA</CardTitle>
        </CardHeader>
        <CardContent>
          {data.volta_integracao_onibus_metro && (
            <TransportItem 
              label="Integração Ônibus/Metrô" 
              valor={data.volta_integracao_onibus_metro_valor || 0} 
            />
          )}
          {data.volta_integracao_onibus_trem && (
            <TransportItem 
              label="Integração Ônibus/Trem" 
              valor={data.volta_integracao_onibus_trem_valor || 0} 
            />
          )}
          {data.volta_onibus_municipal && (
            <TransportItem 
              label="Ônibus Municipal" 
              valor={data.volta_onibus_municipal_valor || 0} 
            />
          )}
          {data.volta_onibus_intermunicipal && (
            <TransportItem 
              label="Ônibus Intermunicipal" 
              valor={data.volta_onibus_intermunicipal_valor || 0} 
            />
          )}
          {data.volta_metro_trem && (
            <TransportItem 
              label="Metrô ou Trem" 
              valor={data.volta_metro_trem_valor || 0} 
            />
          )}
          {data.volta_outros && (
            <TransportItem 
              label={`Outros${data.volta_outros_descricao ? ` (${data.volta_outros_descricao})` : ''}`} 
              valor={data.volta_outros_valor || 0} 
            />
          )}
          {!data.volta_integracao_onibus_metro && !data.volta_integracao_onibus_trem && 
           !data.volta_onibus_municipal && !data.volta_onibus_intermunicipal && 
           !data.volta_metro_trem && !data.volta_outros && (
            <p className="text-muted-foreground text-sm">Nenhum meio de transporte selecionado</p>
          )}
        </CardContent>
      </Card>

      {/* Tipo de Cartão */}
      <Card>
        <CardHeader>
          <CardTitle>Tipo de Cartão</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="font-medium">{getTipoCartaoLabel()}</p>
        </CardContent>
      </Card>

      {/* Total Diário */}
      <Card className="bg-primary/5">
        <CardContent className="pt-6">
          <div className="text-center">
            <p className="text-lg">
              Utilizando diariamente{' '}
              <span className="text-2xl font-bold text-primary">
                R$ {(data.total_diario || 0).toFixed(2)}
              </span>
              {' '}para locomoção entre residência e trabalho.
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Checkbox de Confirmação */}
      <Card className="border-yellow-500 bg-yellow-50/50">
        <CardContent className="pt-6">
          <div className="flex items-start space-x-3">
            <Checkbox
              checked={transporteConfirmado}
              onCheckedChange={onConfirmChange}
              id="transporte-confirmacao"
            />
            <Label 
              htmlFor="transporte-confirmacao" 
              className="cursor-pointer leading-relaxed"
            >
              Confirmo estar ciente e de acordo com o valor informado de vale transporte.
            </Label>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
